<template>
    <!-- 运费订单 -->
    <div class="billOperationRecord public_Spacing receipt-shipping-page">
        <div class="pulbic_oparetionBlock receipt-filter-card">
            <div class="receipt-card-title">
                <div>
                    <div class="receipt-section-title">筛选条件</div>
                    <div class="receipt-section-subtitle">组合条件后查询，可快速定位收料运费订单</div>
                </div>
            </div>
            <div class="public_criteriaRange receipt-filter-fields">
                <div class="public_oparetionBlock_Menu receipt-filter-item">
                    <label class="public_lbSty">装货地</label>
                    <el-select class="public_optionSty dropDown_Define" v-model="enterpriseTwo" placeholder="请选择装货地" filterable remote :remote-method="filterEnterprise">
                        <el-option v-for="item in filteredEnterpriseOptions" :key="item.SETTB99ID"
                            :label="item.SETTB99CA00" :value="item.SETTB99ID">
                        </el-option>
                    </el-select>
                </div>
                <div class="public_oparetionBlock_Menu receipt-filter-item">
                    <label class="public_lbSty">卸货地</label>
                    <el-select class="public_optionSty dropDown_Define long_input" v-model="enterpriseTwoXie" placeholder="请选择卸货地">
                        <el-option v-for="item in enterpriseList" :key="item.ORMTB470CA33"
                            :label="item.ORMTB470CA33" :value="item.ORMTB470CA33">
                        </el-option>
                    </el-select>
                </div>
                <div class="public_oparetionBlock_Menu receipt-filter-item">
                    <label class="public_lbSty">车牌号</label>
                    <div class="el-select public_optionSty">
                        <div class="el-input el-input--suffix">
                            <input class="el-input__inner pulic_carNumber" type="text" placeholder="请输入车牌号" v-model="carNumber" />
                        </div>
                    </div>
                </div>
                <div class="public_oparetionBlock_Menu receipt-filter-item">
                    <label class="public_lbSty">物料类型</label>
                    <el-select class="public_optionSty dropDown_Define" v-model="materielMo" placeholder="请选择物料"
                        filterable>
                        <el-option v-for="item in materielOptions" :key="item.SETTB109CA00" :label="item.SETTB109CA00"
                            :value="item.SETTB109CA00">
                        </el-option>
                    </el-select>
                </div>
                <div class="public_oparetionBlock_Menu receipt-filter-item">
                    <label class="public_lbSty">完成状态</label>
                    <el-select class="public_optionSty dropDown_Define" v-model="SETTB122CA07" placeholder="请选择状态">
                        <el-option v-for="item in dataStatusOperation" :key="item.value" :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="public_operatArea receipt-toolbar">
                <div class="receipt-date-shortcuts">
                    <span class="pulic_operatArea_now pulic_cursor receipt-date-pill" :class="dateNowDayActive ? 'public_dateActive' : ''"
                        @click="getNowDay">当日</span>
                    <span class="public_operatArea_yesterday pulic_cursor receipt-date-pill"
                        :class="dateYesterdayActive ? 'public_dateActive' : ''" @click="getYesterday">昨天</span>
                    <span class="pulic_operatArea_now pulic_cursor receipt-date-pill"
                        :class="dateNowMonthActive ? 'public_dateActive' : ''" @click="sameMonth">当月</span>
                    <span class="public_operatArea_yesterday pulic_cursor receipt-date-pill"
                        :class="dateLastMonthActive ? 'public_dateActive' : ''" @click="lastMonth">上月</span>
                    <div class="public_operatArea_timePicker pulic_cursor pulic_cursor_round receipt-date-picker-wrap">
                        <el-date-picker v-model="date" value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange"
                            range-separator="至" :picker-options="startDateDisabled" @change="datePickerChange"
                            start-placeholder="开始日" end-placeholder="结束日" class="pulic_cursor receipt-date-picker">
                        </el-date-picker>
                    </div>
                </div>
                <div class="public_operatBtn receipt-actions">
                    <el-button type="primary" class="receipt-query-btn" @click="queryClick">查询</el-button>
                    <el-button class="receipt-reset-btn" @click="reset">重置</el-button>
                </div>
            </div>
        </div>
        <div class="pulbic_oparetionBlock public_statisticsInfo receipt-stat-grid">
            <div class="public_statistics billDetails-statistics receipt-stat-card receipt-stat-card-trips">
                <div class="public_statisticsContent receipt-stat-content">
                    <img class="imgStatistics receipt-stat-icon" src="../../assets/images/orderStatistics/trainNumber2.png" />
                    <div>
                        <div class="payType receipt-stat-label">车次</div>
                        <div class="payType_num receipt-stat-value">{{ wccc || 0 }}</div>
                    </div>
                </div>
            </div>
            <div class="public_statistics billDetails-statistics receipt-stat-card receipt-stat-card-weight">
                <div class="public_statisticsContent receipt-stat-content">
                    <img class="imgStatistics receipt-stat-icon" src="../../assets/images/orderStatistics/weight2.png" />
                    <div>
                        <div class="payType receipt-stat-label">重量</div>
                        <div class="payType_num receipt-stat-value">{{ wczl || 0 }}</div>
                    </div>
                </div>
            </div>
            <div class="public_statistics billDetails-statistics receipt-stat-card receipt-stat-card-amount">
                <div class="public_statisticsContent receipt-stat-content">
                    <img class="imgStatistics receipt-stat-icon" src="../../assets/images/orderStatistics/weight2.png" />
                    <div>
                        <div class="payType receipt-stat-label">结算金额</div>
                        <div class="payType_num receipt-stat-value">{{ wcje || 0 }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="billOperationRecord-table pulbic_table_container receipt-table-card">
            <div class="receipt-table-toolbar">
                <div>
                    <div class="receipt-section-title">订单列表</div>
                    <div class="receipt-section-subtitle">查看接单、装卸货、重量与结算状态</div>
                </div>
                <div class="receipt-table-total">共 {{ pagingPageMo || 0 }} 条</div>
            </div>
            <el-table tooltip-effect="dark" :data="tableData" style="width: 100%;" stripe highlight-current-row
                :default-sort="{ prop: 'waterNum', order: 'descending' }" :header-cell-style="{
                    color: 'rgba(38,50,56,1)',
                    background: 'rgba(232,246,255,1)',
                    'font-weight': 'bold',
                }" class="public_tableColumn receipt-main-table">
                <el-table-column prop="ORMTB470CA16" sortable fixed="left" label="接单时间" min-width="170" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="ORMTB470CA05" label="装货地" min-width="150" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="ORMTB470CA33" label="卸货地" min-width="150" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="ORMTB470CA07" label="物料类型" min-width="120" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="ORMTB470CA01" label="车牌号" min-width="120" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="ORMTB470CC08" label="卸货重量(吨)" min-width="140">
                </el-table-column>
                <el-table-column prop="ORMTB470CC13" label="结算金额(元)" min-width="140">
                </el-table-column>
                <el-table-column fixed="right" prop="ORMTB440CF01text" label="完成状态" width="130">
                    <template slot-scope="scope">
                        <span class="receipt-status-tag" :class="{
                            'receipt-status-done': scope.row.ORMTB440CF01text === '已完成' || scope.row.ORMTB440CF01text === '完成',
                            'receipt-status-wait': scope.row.ORMTB440CF01text !== '已完成' && scope.row.ORMTB440CF01text !== '完成'
                        }">{{ scope.row.ORMTB440CF01text || '--' }}</span>
                    </template>
                </el-table-column>
                <template slot="empty">
                    <div class="receipt-empty">
                        <div class="receipt-empty-title">暂无收料运费订单</div>
                        <div class="receipt-empty-desc">请调整筛选条件后重新查询</div>
                    </div>
                </template>
            </el-table>
            <div class="pulbic_pagesize receipt-pagination">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page.sync="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="limitMo"
                    layout="total,sizes, prev, pager, next, jumper" :total="pagingPageMo">
                </el-pagination>
            </div>
        </div>
        <div class="">
            <el-dialog title="订单详情" :visible.sync="oerderDetilsShow" width="56%" top="6vh" custom-class="receipt-detail-dialog" @close="detailsList = ''"
                :closeOnClickModal="false" append-to-body>
                <div class="DetailsWater-Dialog">
                    <div class="DWD-li">
                        <div class="DWD-li-title">流水号</div>
                        <div class="DWD-li-text">{{ detailsList.ORMTB470CA00 || '' }}</div>
                    </div>
                    <div class="DWD-li">
                        <div class="DWD-li-title">发单人</div>
                        <div class="DWD-li-text">{{ detailsList.ORMTB470CA40 || '' }}</div>
                    </div>
                    <!-- <div class="DWD-li">
            <div class="DWD-li-title">运费(每吨)</div>
            <div class="DWD-li-text">
              {{ detailsList.ORMTB470CA14 || '' }}元
            </div>
          </div> -->
                    <div class="DWD-li">
                        <div class="DWD-li-title">到货价</div>
                        <div class="DWD-li-text">{{ detailsList.daohuoMoney || '' }}元</div>
                    </div>
                    <!-- <div class="DWD-li">
                        <div class="DWD-li-title">运费是否含税</div>
                        <div class="DWD-li-text">{{ detailsList.ORMTB470CA70 }}</div>
                    </div>
                    <div class="DWD-li">
                        <div class="DWD-li-title">亏吨范围(吨)</div>
                        <div class="DWD-li-text">
                            {{ detailsList.ORMTB470CA50 || '' }}吨
                        </div>
                    </div> -->
                    <!-- <div class="DWD-li">
                        <div class="DWD-li-title">超时取消时间(小时)</div>
                        <div class="DWD-li-text">
                            {{ detailsList.ORMTB470CA54 || '' }}小时
                        </div>
                    </div> -->
                    <!-- <div class="DWD-li">
                        <div class="DWD-li-title">运费卸货净重规则</div>
                        <div class="DWD-li-text">{{ detailsList.ORMTB460CA38 || '' }}</div>
                    </div>
                    <div class="DWD-li">
                        <div class="DWD-li-title">运费结算甩零规则</div>
                        <div class="DWD-li-text">{{ detailsList.ORMTB460CA39 || '' }}</div>
                    </div>

                    <div class="DWD-li">
                        <div class="DWD-li-title">卸货时间</div>
                        <div class="DWD-li-text">{{ detailsList.ORMTB460CA40 || '' }}</div>
                    </div> -->
                    <!-- <div class="DWD-li">
						<div class="DWD-li-title">接单人</div>
						<div class="DWD-li-text">{{detailsList.ORMTB470CA12||''}}</div>
					</div> -->
                    <div class="DWD-li">
                        <div class="DWD-li-title">接单车号</div>
                        <div class="DWD-li-text">{{ detailsList.ORMTB470CA01 || '' }}</div>
                    </div>
                    <!-- <div class="DWD-li">
						<div class="DWD-li-title">接单方式</div>
						<div class="DWD-li-text">
							{{detailsList.ORMTB440CF00=='ZG'?'直供':detailsList.ORMTB440CF00=='LS'?'零售':detailsList.ORMTB440CF00=='QD'?'抢单':''}}
						</div>
					</div> -->
                    <div class="DWD-li">
                        <div class="DWD-li-title">接单时间</div>
                        <div class="DWD-li-text">{{ detailsList.ORMTB470CA16 || '' }}</div>
                    </div>
                    <div class="DWD-li">
                        <div class="DWD-li-title">出厂结算时间</div>
                        <div class="DWD-li-text">{{ detailsList.ORMTB470CA17 || '' }}</div>
                    </div>
                    <div class="DWD-li">
                        <div class="DWD-li-title">票号</div>
                        <div class="DWD-li-text">{{ detailsList.ORMTB470CA48 || '' }}</div>
                    </div>
                    <div class="DWD-li">
                        <div class="DWD-li-title">完成结算时间</div>
                        <div class="DWD-li-text">{{ detailsList.ORMTB470CC02 || '' }}</div>
                    </div>
                    <!-- <div class="DWD-li">
						<div class="DWD-li-title">回执时间</div>
						<div class="DWD-li-text">{{detailsList.ORMTB440CE00||''}}</div>
					</div> -->
                    <!-- <div class="DWD-li">
                        <div class="DWD-li-title">原因</div>
                        <div class="DWD-li-text">{{ detailsList.ORMTB470CA29 || '' }}</div>
                    </div> -->
                    <div class="DWD-li">
                        <div class="DWD-li-title">磅单审核拒绝原因</div>
                        <div class="DWD-li-text">{{ detailsList.ORMTB470CA44 || '' }}</div>
                    </div>
                    <div class="DWD-li" v-if="uobj.pertb005.pertb005cb00 == 'CUS-1'">
                        <div class="DWD-li-title">修改流水备注</div>
                        <el-tooltip placement="top" :content="detailsList.ORMTB470CN01">
                            <div class="DWD-li-text">
                                {{ detailsList.ORMTB470CN01 || '' }}
                            </div>
                        </el-tooltip>
                    </div>
                    <div class="DWD-table">
                        <div class="DWD-table-left-title">
                            <div></div>
                            <div>接单</div>
                            <div>出厂结算</div>
                            <div>完成结算</div>
                            <!-- <div>回执</div> -->
                        </div>
                        <div class="DWD-table-left-flex">
                            <div>物料</div>
                            <div>{{ detailsList.ORMTB470CA07 || '' }}</div>
                            <div>{{ detailsList.ORMTB470CA19 || '' }}</div>
                            <div>{{ detailsList.ORMTB470CA19 || '' }}</div>
                        </div>
                        <div class="DWD-table-left-flex">
                            <div>重量</div>
                            <div>{{ detailsList.ORMTB470CB02 || 0 }}</div>
                            <div>{{ detailsList.ORMTB470CA21 || 0 }}</div>
                            <div>{{ detailsList.ORMTB470CC08 || 0 }}</div>
                            <!-- <div v-else></div> -->
                        </div>
                        <div class="DWD-table-left-flex">
                            <div>一口价</div>
                            <div>{{ detailsList.ORMTB470CA73 || '' }}</div>
                            <div>{{ detailsList.ORMTB470CA73 || '' }}</div>
                            <div>{{ detailsList.ORMTB470CA73 || '' }}</div>
                        </div>
                        <div class="DWD-table-left-flex">
                            <div>物料金额</div>
                            <div>{{ detailsList.ORMTB470CA09 || 0 }}</div>
                            <div>{{ detailsList.ORMTB470CA23 || 0 }}</div>
                            <div>{{ detailsList.ORMTB470CA23 || 0 }}</div>
                        </div>
                        <!-- <div class="DWD-table-left-flex">
                            <div>扣除运费</div>
                            <div>{{ detailsList.ORMTB470CC06 || 0 }}</div>
                            <div>{{ detailsList.ORMTB470CC06 || 0 }}</div>
                            <div>{{ detailsList.ORMTB470CC06 || 0 }}</div>
                        </div>
                        <div class="DWD-table-left-flex">
                            <div>结算运费</div>
                            <div>{{ detailsList.ORMTB470CC12 || 0 }}</div>
                            <div>{{ detailsList.ORMTB470CC12 || 0 }}</div>
                            <div>{{ detailsList.ORMTB470CC12 || 0 }}</div>
                        </div>
                        <div class="DWD-table-left-flex">
                            <div>额外费用</div>
                            <div>{{ detailsList.ORMTB470CA72 || 0 }}</div>
                            <div>{{ detailsList.ORMTB470CA72 || 0 }}</div>
                            <div>{{ detailsList.ORMTB470CA72 || 0 }}</div>
                        </div>
                        <div v-if="uobj.pertb005.pertb005cb00 == 'CUS-1'" class="DWD-table-left-flex">
                            <div>管理费</div>
                            <div>0</div>
                            <div>0</div>
                            <div>{{ detailsList.ORMTB470CA60 || 0 }}</div>
                        </div>
                        <div v-if="uobj.pertb005.pertb005cb00 == 'CUS-1'" class="DWD-table-left-flex">
                            <div>运费补贴</div>
                            <div>0</div>
                            <div>0</div>
                            <div>{{ detailsList.ORMTB470CA71 || 0 }}</div>
                        </div> -->
                    </div>
                </div>
                <!-- div class="DetailsWater-img">
					<div class="DetailsWater-img-text">回执记录</div>
					<el-image style="width: 80px; height: 80px" :src="DetailsWaterurl"
						:preview-src-list="DetailsWatersrcList">
					</el-image>
				</div> -->
                <div v-if="
                    detailsList.ORMTB470CA67 &&
                    (detailsList.ORMTB470CA04 == '10000106' ||
                        detailsList.ORMTB470CA04 == '10000107' ||
                        detailsList.ORMTB440CA42 == '1')
                " class="DetailsWater-img">
                    <div class="DetailsWater-img-text">出厂磅单:</div>
                    <el-image style="width: 80px; height: 80px" :src="detailsList.ORMTB470CA67"
                        :preview-src-list="DetailsWeightrcList">
                    </el-image>
                </div>
                <div v-if="detailsList.ORMTB470CA35" class="DetailsWater-img">
                    <div class="DetailsWater-img-text">卸货磅单:</div>
                    <el-image style="width: 80px; height: 80px" :src="detailsList.ORMTB470CA35"
                        :preview-src-list="DetailsWeightrcList">
                    </el-image>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import qs from 'qs'
import { createLogger } from 'vuex'
import debounce from '../../api/debounce'
import customerSearchMixin from '@/mixins/customerSearchMixin'
import enterpriseSearchMixin from '@/mixins/enterpriseSearchMixin'
export default {
  mixins: [customerSearchMixin],
    data() {
        return {
            weightOpt: {
                tare: '',
                gross: '',
                jsprice: '',
                price: '',
            },
            loadingBut: false,
            confirmTxt: 0,
            inputWeightShow: false, // 输入磅单信息弹窗
            isorderAuditText: '',
            oerderDetilsShow: false,
            orderAuditShow: false,
            orderAuditShow1: false,
            orderAuditShow2: false,
            isorderAuditShow: false,
            returnReceiptShow: false,
            uobj: this.$store.state.uobj, //登陆缓存--用户信息
            date: [], //日期
            startTime: '',
            endTime: '',
            dateNowDayActive: false,
            dateYesterdayActive: false,
            dateNowMonthActive: false,
            dateLastMonthActive: false,
            twolevelUserLogin: true,
            timeIndex: 0, //判断第几次切换当月时间
            sameMonthTime: '', //目前月份
            currentMonthTime: '', //目前月份--上月+1
            tableData: [],
            ORMTB440CA00: '',
            ORMTB470CA12: '',
            ORMTB470CA40: '',
            ORMTB410CA04: '',
            materialOptions: [],
            materialTypeValue: '',
            carNum: '',
            materielMo: '',
            materielOptions: [
                {
                    SETTB109CA00: '全部',
                    SETTB109ID: '',
                },
            ],
            // 结算方式
            dataStatusOperation0: [
                {
                    value: '',
                    label: '全部',
                },
                {
                    value: '1',
                    label: '线上结算',
                },
                {
                    value: '2',
                    label: '线下结算',
                },
            ],

            // 状态
            dataStatusOperation: [
                {
                    value: '',
                    label: '全部',
                },
                {
                    value: '0',
                    label: '已接单',
                },
                {
                    value: '1',
                    label: '提货中',
                },
                {
                    value: '2',
                    label: '已出厂',
                },
                {
                    value: '3',
                    label: '待审核磅单',
                },
                {
                    value: '4',
                    label: '待完成磅单',
                },
                {
                    value: '5',
                    label: '完成',
                },
                {
                    value: '-1',
                    label: '取消',
                },
                {
                    value: '-2',
                    label: '取消申请',
                },
            ],
            jscc: 0,
            jsje: 0,
            jszl: 0,
            jsyf: 0,
            pdcc: 0,
            pdje: 0,
            pdzl: 0,
            pdyf: 0,
            wccc: 0,
            wcje: 0,
            wcyf: 0,
            jsyfsjtj: 0,
            glf: 0,
            wczl: 0,
            // 查询
            customerMo: '', //客户--查询
            SETTB122CA07: '', //数据状态
            ORMTB470CA58: '', //运费结算状态
            billOperationAdd: false,
            filteredEnterpriseOptions: [],
      enterpriseTwoOptionList: [
                {
                    SETTB109CA00: '全部',
                    SETTB109ID: '',
                },
            ], //二级企业下拉框--新增
            enterpriseList: [
                {
                    ORMTB470CA33: '全部',
                },
            ],
            enterpriseTwo: '', //二级企业
            carNumber: '', //车牌号
            pageMo: 1, //默认列表页码
            limitMo: 10, //每页的条数
            pagingPageMo: 0, //分页--数据列表共有的条数
            currentPage: 1, //设置当前页默认为1
            // 列设置
            checkAll: true,
            checkedCities: [
                '派单时间',
                '派单编号',
                '企业名称',
                '客户名称',
                '车牌号',
                '订单物料',
                '出厂物料',
                '重量',
                '完成状态',
                '申请状态',
            ],
            cities: [
                '派单时间',
                '派单编号',
                '企业名称',
                '客户名称',
                '车牌号',
                '订单物料',
                '出厂物料',
                '重量',
                '完成状态',
                '申请状态',
            ],
            isIndeterminate: false,
            // 详情
            billOperationDetails: false,
            detailsList: '', //详情列表
            tableHeadList: [
                // {
                // 	prop: 'ORMTB440CA19',
                // 	label: '派单时间',
                // 	width: 110
                // },
                // {
                // 	prop: 'ORMTB440CA00',
                // 	label: '派单编号',
                // 	width: 130
                // },
                // {
                // 	prop: 'ORMTB440CA05',
                // 	label: '企业名称',
                // },
                // {
                // 	prop: 'ORMTB440CA03',
                // 	label: '客户名称',
                // },

                // {
                //     prop: 'ORMTB470CA01',
                //     label: '接单车号',
                //     width: 100,
                // },
                {
                    prop: 'ORMTB470CA07',
                    label: '物料类型',
                    width: 100,
                },
                // {
                //     prop: 'ORMTB470CA19',
                //     label: '出厂物料',
                //     width: 100,
                // },
                // {
                //     prop: 'ORMTB470CB02',
                //     label: '接单重量',
                //     width: 100,
                // },
                // {
                //     prop: 'ORMTB470CA17',
                //     label: '出厂结算时间',
                //     width: 120,
                // },
                // {
                //     prop: 'ORMTB470CC02',
                //     label: '完成结算时间',
                //     width: 120,
                // },
                // {
                // 	prop: 'ORMTB470CA23',
                // 	label: '出厂结算金额',
                // 	width: 120
                // },
                // {
                // 	prop: 'ORMTB470CA23',
                // 	label: '完成结算金额',
                // 	width: 120
                // },
                // {
                // 	prop: 'ORMTB470CA24',
                // 	label: '流水号',
                // 	width: 130
                // }
                // {
                // 	prop: 'ORMTB440CF01text',
                // 	label: '完成状态',
                // 	width: 100
                // },
                // {
                // 	prop: 'auditText',
                // 	label: '申请状态',
                // 	width: 100
                // }
            ],
            tableHeadListInit: [
                // {
                //   prop: 'ORMTB470CA16',
                //   label: '派单时间',
                // },
                // {
                //   prop: 'ORMTB470CA00',
                //   label: '派单编号',
                // },
                // {
                //   prop: 'ORMTB470CA05',
                //   label: '企业名称',
                // },
                // {
                //   prop: 'ORMTB470CA12',
                //   label: '客户名称',
                // },

                // {
                //   prop: 'ORMTB470CA01',
                //   label: '车牌号',
                // },
                // {
                //   prop: 'ORMTB470CA07',
                //   label: '订单物料',
                // },
                // {
                //   prop: 'ORMTB440CC02',
                //   label: '完成物料',
                // },
                // {
                //   prop: 'ORMTB440CA10',
                //   label: '重量',
                // },
                {
                    prop: 'ORMTB440CF01text',
                    label: '完成状态',
                },
                // {
                //   prop: 'auditText',
                //   label: '申请状态',
                // },
            ],
            // 离线订单
            orlxOrdeOptions: [
                {
                    value: '',
                    label: '全部',
                },
                {
                    value: '1',
                    label: '是',
                },
            ],
            lxorde: '',
            examineObj: {},
            isRefresh: true,
            isRefreshSetInterval: '',
            // quanpDisabled: false,
            // 历史缓存
            currentUrl: this.$route.path,
            historyInfo: '',
            // 时间限制
            // 限制开始日期不能超过当前日期
            startDateDisabled: {
                disabledDate(time) {
                    return time.getTime() > Date.now()
                },
            },
            solelist: [],
            DetailsWaterurl: '',
            DetailsWatersrcList: [],
            DetailsWeightrcList: [],
            materialList: [],
            materialValue: '',
            listTick: null, // 列表刷新定时器
            timeType: '1',
            ewmDetilsShow: false,
            ewmDetails: [],
            ewmdetailsList: '', //二维码详情
            formData: {
                name: '',
                brand: '',
                unit: '',
                category: [],
                desc: '',
                fileList: [],
				fileId:'',
                img: [],
            },
            isname: true,
            dialogImageUrl: undefined,
            videoFlag: false,
            uploadFileUrl: process.env.VUE_APP_BASE_API + '/system/image/uploadFile', // 上传的图片服务器地址
            dialogVisible: false,
            bdurlList: [],
            dcjsiput: true,

            /*/ 自建厂家出厂榜单data START/*/
            fileListccbd: [],
            dialogVisibleimg: false,
            formdata: new FormData(),
            dialogImageUrlzjccbd: '',
            addimg: [],
            removeimg: [],
            ruleForm: {
                csAvatar: '',
				fileId:''
            },
            orXgOrdeOptions: [
                {
                    value: '',
                    label: '全部',
                },
                {
                    value: '1',
                    label: '是',
                },
            ],
            xgorde: '',
            orderId: '', //订单
            settlement: '', //扣除发单人运费
            jsyfgsj: '', //结算给司机运费
            /*/ 自建厂家出厂榜单data END/*/

            // headers: {
            //  Authorization: "Bearer " + getToken(),
            // }
            newOrderId: '', //订单ID
            dcmore: '',
            enterpriseTwoXie:'全部'
        }
    },
    watch: {
        weightOpt: {
            handler(val) {
                if ((val.tare || val.tare === 0) && (val.price || val.price === 0)) {
                    let tare = parseFloat(val.tare)

                    // let gross = parseFloat(val.gross)
                    // debounce(this.getSettlementAmount, 500)
                    // this.detailsList.ORMTB470CA21 = (tare - gross).toFixed(2)

                    if (this.weightOpt.tare >= 0) {
                        debounce(this.getSettlementAmount, 500)
                    }
                    // else {

                    // }
                } else {
                    // this.detailsList.ORMTB470CA21 = ''
                    this.weightOpt.jsprice = ''
                }
            },
            deep: true,
        },
        // 'detailsList.ORMTB440CA04'() {
        //     this.getSelectMaterial()
        // }
    },
    created() {
        var list = ''
        list = this.$store.state.solelist
        // 赋值，缓存销毁
        this.historyInfo = JSON.parse(sessionStorage.getItem(this.currentUrl))
        sessionStorage.removeItem(this.currentUrl)
        if (this.historyInfo != null && this.historyInfo != '') {
            this.init()
        }
        // else {
        // 	this.getNowDay();
        // }
        var path = this.$route.path
        // console.log(path)
        if (path === '/receiptShippingOrder') {
            path = '/Home' + path
        }
        this.solelist = this.$baseAPI.querSoleList(list, path) //获取权限列表
    },
    mounted() {
        if (this.historyInfo == null && this.$route.query.mark == null) {
            this.getNowDay()
            this.startTime = this.date[0]
            this.endTime = this.date[1]
            this.dateNowDayActive = true
        }

        this.optionLists();
        this.optionListsXie();
        this.materielMoPost();
        // this.enterprise0ptions()
        this.startListTimer()
        // console.log(this.$store.state.uobj)
    },
    activated() {
      this.startListTimer()
    },
    deactivated() {
      this.stopListTimer()
    },
    // 存储数据
    beforeDestroy() {
      this.stopListTimer()
        clearInterval(this.listTick)
        this.listTick = null
        this.startTime = this.dateFtt('yyyy-MM-dd hh:mm:ss', new Date(this.date[0]))
        this.endTime = this.dateFtt('yyyy-MM-dd hh:mm:ss', new Date(this.date[1]))
        var obj = {
            startTime: this.startTime,
            endTime: this.endTime, //开始时间
            ORMTB440CA02: this.ORMTB440CA02, //客户id
            ORMTB400CA03: this.ORMTB400CA03, //客户名称
            ORMTB440CA04: this.ORMTB440CA04, //客户名称
            ORMTB440CA06: this.ORMTB440CA06, //二级企业id
            ORMTB440CF01: this.ORMTB440CF01, //二级企业名称
            ORMTB440CA00: this.ORMTB440CA00, //数据状态--转换
            ORMTB440CA01: this.ORMTB440CA01, //数据状态--名字
            currentPage: this.currentPage, //当前页数
            pageMo: this.pageMo, //页码
            limitMo: this.limitMo, //每页条数
            dateNowDayActive: this.dateNowDayActive,
            dateYesterdayActive: this.dateYesterdayActive,
            dateNowMonthActive: this.dateNowMonthActive,
            dateLastMonthActive: this.dateLastMonthActive,
            ORMTB440CA00: this.ORMTB440CA00,
        }
        sessionStorage.setItem(this.currentUrl, JSON.stringify(obj))
    },
    computed: {
        uploadDisabled: function () {
            // console.log(this.ruleForm.csAvatar)
            return this.ruleForm.csAvatar != ''
        },
    },
    methods: {
    filterEnterprise(query) {
      if (!query) {
        this.filteredEnterpriseOptions = this.enterpriseTwoOptionList.slice(0, 100)
        return
      }
      const q = query.toLowerCase()
      this.filteredEnterpriseOptions = this.enterpriseTwoOptionList.filter(item =>
        (item.SETTB99CA00 || '').toLowerCase().includes(q) ||
        (item.SETTB99CA00PY || '').toLowerCase().includes(q)
      )
    },
        startListTimer() {
          if (this.listTick) return
          this.listTick = setInterval(() => {
            if (document.hidden) return
            this.queryClick()
          }, 1000 * 60)
        },
        stopListTimer() {
          if (!this.listTick) return
          clearInterval(this.listTick)
          this.listTick = null
        },
        reset(){
            this.enterpriseTwo = '';
            this.enterpriseTwoXie = '全部';
            this.carNumber = '';
            this.materielMo = '';
            this.SETTB122CA07 = '';
            this.getNowDay()
            this.startTime = this.date[0]
            this.endTime = this.date[1]
            this.dateNowDayActive = true
            this.pageList();
        },
        handInput() {
            this.getFree()
        },
        //获取结算运费
        getFree() {
            var dataObj = {
                ORMTB470ID: this.examineObj.ORMTB470ID,
                ORMTB470CC05: this.detailsList.ORMTB470CC05,
                ORMTB470CA14: this.detailsList.ORMTB470CA14,
                ORMTB470CA33: this.detailsList.ORMTB470CA33,
                ORMTB470CA72: this.detailsList.ORMTB470CA72,
            }
            this.axios.post('/request/yfBeforePay', dataObj).then(res => {
                if (res.data.code == 200) {
                    console.log(res, 'oooo')
                    this.settlement = res.data.data.ORMTB470CC06
                    this.jsyfgsj = res.data.data.ORMTB470CC12
                } else {
                    this.$message({
                        message: res.data.message,
                        type: 'error',
                    })
                }
            })
        },
        cancelPlan(row) {
            //取消要货计划
            this.axios
                .post('orm/ormtb470/cancelGoodsPlan', { ORMTB470ID: row.ORMTB470ID })
                .then(res => {
                    if (res.data.code == 200) {
                        console.log(res)
                        this.$message({
                            message: '成功',
                            type: 'success',
                        })
                        this.pageList()
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error',
                        })
                    }
                })
        },
        // 值改变 重新获取结算金额
        async materialChange(val) {
            if (val == this.detailsList.ORMTB470CA18) {
                this.weightOpt.price = this.detailsList.ORMTB470CA08
            } else {
                await this.queryMaterialPrice(val)
            }
            this.getSettlementAmount() //获取结算金额
        },
        // 根据物料id 查询单价
        async queryMaterialPrice(ORMTB440CC01) {
            let url = '/orm/ormtb440/unitPriceAuto'
            let params = {
                ORMTB440CC01, // 结算物料id
                ORMTB440CA02: this.detailsList.ORMTB410CA01, //客户id
                ORMTB440CA04: this.detailsList.ORMTB470CA04, // 二级企业ID
                ORMTB440ID: this.newOrderId,
            }
            params = qs.stringify(params)
            let header = {
                'Content-Type': 'application/x-www-form-urlencoded',
            }
            let res = await this.axios.post(url, params, {
                header,
            })
            if (res.data.code === 200) {
                this.weightOpt.price = res.data.data
            }
        },
        //删除图片
        handleRemove(file, fileList) {
            console.log(file)
            //   判断是否是正确格式图片才能执行删除
            if (file && file.status === 'success') {
                let Pics = this.formData.fileList
                Pics.forEach((item, index) => {
                    if (file.name == item.name) {
                        Pics.splice(index, 1)
                    }
                })
            }
            this.dialogImageUrl = ''
			this.formData.fileId = ''
            this.bdurlList = []
            this.dialogVisible = false
            //   console.log(this.formData.fileList);
        },
        //查看图片
        handlePictureCardPreview(file) {
            // this.dialogImageUrl = file.url;
            console.log(file)
            // this.dialogVisible = true;
        },
        handleChange(file, fileList) {
            console.log(fileList)
            //   console.log(file);
        },

        getocrFun(data) {
            let loading = this.$loading({
                lock: true,
                text: '识别中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)',
            })
            var postData = {
                url: data,
            }
            var url = '/orm/ormtb470/getOcr'

            this.axios
                .post(url, postData)
                .then(res => {
                    setTimeout(() => {
                        loading.close()
                    }, 400)
                    if (res.data.code == 200) {
                        console.log(res)
                        // this.$message({
                        // 	message: '成功',
                        // 	type: 'success'
                        // });
                        // this.pageList()
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error',
                        })
                    }
                })
                .catch(() => {
                    loading.close()
                })
        },
        //   手动上传
        //   submitUpload() {
        //     console.log(this.$refs.upload)
        //     this.$refs.upload.submit();
        //   },
        // 在使用http-request方法的时候，调用的事件必须以param为参数，通过param.file取得文件。
        UploadImage(param) {
            const formData = new FormData()
            formData.append('file', param.file)
            // formData.append('ORMTB470CA00', this.ORMTB470CA00)
            let loading = this.$loading({
                lock: true,
                text: '上传中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)',
            })
            var url = '/system/uploadBD'

            this.axios
                .post(url, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                })
                .then(res => {
                    setTimeout(() => {
                        loading.close()
                    }, 400)
                    if (res.data.code == 200) {
                        console.log(res)
                        this.$message({
                            message: res.data.data.message,
                            type: 'success',
                        })
                        this.getocrFun(res.data.data.bdurl)
                        this.formData.fileList.push({
                            name: param.file.name,
                            url: res.data.data.bdurl,
                            uid: param.file.uid,
                        })
                        // this.pageList()
                        this.dialogImageUrl = res.data.data.bdurl
						this.formData.fileId = res.data.data.fileId
                        this.bdurlList.push(res.data.data.bdurl)
                        this.dialogVisible = true
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error',
                        })
                    }
                })
                .catch(() => {
                    loading.close()
                })

            // Shoppingupoload(formData)
            //   .then((response) => {
            //     console.log("上传图片成功");
            //     this.formData.fileList.push({
            //       name: param.file.name,
            //       url: response.data.data,
            //       uid: param.file.uid,
            //     });
            //     param.onSuccess(); // 上传成功的图片会显示绿色的对勾
            //     // 但是我们上传成功了图片， fileList 里面的值却没有改变，还好有on-change指令可以使用
            //   })
            //   .catch((response) => {
            //     console.log("图片上传失败");
            //     param.onError();
            //   });
        },
        // 上传检测
        // beforeAvatarUpload(file) {
        // 	const isJPG = file.type === "image/jpeg";
        // 	const isLt2M = file.size / 1024 / 1024 < 2;
        // 	this.isname = true;
        // 	// 不能在foreach中增加else判断,否则会进行多次执行
        // 	//   forEach 会遍历数组中的所有元素，满足条件后还继续执行了循环，
        // 	// 可以通过 try catch 抛出异常的方式跳出循环
        // 	this.formData.fileList.forEach((item, index) => {
        // 		if (file.name === item.name) {
        // 			this.isname = false;
        // 		}
        // 	});
        // 	if (!this.isname) {
        // 		this.$message.error("图片重复");
        // 	}
        // 	if (!isJPG) {
        // 		this.$message.error("上传头像图片只能是 JPG 格式!");
        // 		// this.$refs.upload.handleRemove(file);
        // 	}
        // 	if (!isLt2M) {
        // 		this.$message.error("上传头像图片大小不能超过 2MB!");
        // 		// this.$refs.upload.handleRemove(file);
        // 	}
        // 	return isJPG && isLt2M && this.isname;
        // },
        //控制上传数量提示
        handleExceed(files, fileList) {
            this.$message.warning(`最多上传1个文件`)
        },

        /*/ 自建厂家出厂上传磅单START/*/
        handleChangeSuccess() { },

        handleChangezjccbd(file, fileList) {
            const isJPG =
                file.raw.type === 'image/jpeg' || file.raw.type === 'image/png'
            const isLt5M = file.size / 1024 / 1024 < 5
            if (!isJPG) {
                this.$message.error('上传图片只能是 JPG 、png 格式!')
                fileList.splice(-1, 1) //移除错误文件
                return false
            }
            if (!isLt5M) {
                this.$message.error('上传图片大小不能超过 5MB!')
                fileList.splice(-1, 1)
                return false
            }

            this.addimg = fileList[0].raw
            // this.ruleForm.csAvatar = this.addimg;
            // console.log(file)
            // console.log(fileList)
            this.fileListccbd = []
            let data = new FormData()
            data.append('file', this.addimg)
            let loading = this.$loading({
                lock: true,
                text: '请求中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)',
            })
            var url = '/system/uploadBD'
            this.axios
                .post(url, data, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                })
                .then(res => {
                    setTimeout(() => {
                        loading.close()
                    }, 400)
                    if (res.data.code == 200) {
                        // console.log(res)
                        this.ruleForm.csAvatar = res.data.data.bdurl
						this.ruleForm.fileId = res.data.data.fileId
                        this.fileListccbd = fileList
                        // console.log(this.fileList)
                        this.$message({
                            message: res.data.data.message,
                            type: 'success',
                        })
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error',
                        })
                    }
                })
                .catch(() => {
                    loading.close()
                })
        },

        // 删除活动展示照片
        handleRemovezjccbd(file, fileList) {
            // console.log(fileList)
            var index1 = this.ruleForm.csAvatar.lastIndexOf('2022', '2023')
            var imgdel = this.ruleForm.csAvatar.substring(index1)
            // console.log(imgdel)
            let loading = this.$loading({
                lock: true,
                text: '请求中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)',
            })
            var url = '/orm/ormtb440/deleteFile'
            var postData = {
                fileName: imgdel,
            }
            this.axios
                .post(url, postData)
                .then(res => {
                    setTimeout(() => {
                        loading.close()
                    }, 400)
                    if (res.data.code == 200) {
                        // console.log(res)
                        this.ruleForm.csAvatar = ''
						this.ruleForm.fileId = ''
                        this.formdata = new FormData()
                        this.$message({
                            message: res.data.message,
                            type: 'success',
                        })
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error',
                        })
                    }
                })
                .catch(() => {
                    loading.close()
                })
        },
        // 活动展示照片预览
        handlePictureCardPreviewzjccbd(file) {
            this.dialogImageUrlzjccbd = file.url
            this.dialogVisibleimg = true
        },

        // 渲染编辑获取id
        applyzjccbd() {
            this.fileListccbd = [
                {
                    url: '',
                },
            ] //这里是踩坑的点，必须写
            this.fileListccbd[0].url = res.data.csAvatar //这里是调用接口获取到的值 res.data.csAvatar，赋值就可以回显了
            //this.fileList[0].url 做的是单张图片回显，多张图片回显可以去掉[0]
        },

        /*/ 自建厂家出厂上传磅单END/*/

        // 获取派单物料列表
        getSelectMaterial(row) {
            var postData = {
                SETTB99ID: row.ORMTB470CA04,
            }
            this.materialList = []
            postData = qs.stringify(postData)
            var url = '/set/settb109/select_material'
            this.axios
                .post(url, postData, {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                })
                .then(res => {
                    if (res.data.code == 200) {
                        this.materialList = res.data.data
                        // this.materialValue = this.detailsList.ORMTB440CC01
                        if (this.detailsList.ORMTB470CA18) {
                            this.materialValue = this.detailsList.ORMTB470CA18
                        } else {
                            this.materialValue = this.detailsList.ORMTB470CA06
                            // console.log(this.detailsList)
                            this.queryMaterialPrice(this.materialValue)
                        }
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error',
                        })
                    }
                })
                .catch(() => {
                    loading.close()
                })
        },
        //初始化数据
        init() {
            this.startTime = this.historyInfo.startTime
            this.endTime = this.historyInfo.endTime
            this.date = [this.startTime, this.endTime]
            this.ORMTB440CA02 = this.historyInfo.ORMTB440CA02
            this.ORMTB400CA03 = this.historyInfo.ORMTB400CA03
            this.ORMTB440CA04 = this.historyInfo.ORMTB440CA04
            this.ORMTB440CA06 = this.historyInfo.ORMTB440CA06
            this.ORMTB440CF01 = this.historyInfo.ORMTB440CF01
            this.ORMTB440CA00 = this.historyInfo.ORMTB440CA00
            this.ORMTB440CA01 = this.historyInfo.ORMTB440CA01
            this.currentPage = this.historyInfo.currentPage
            this.pageMo = this.historyInfo.pageMo
            this.limitMo = this.historyInfo.limitMo
            this.dateNowDayActive = this.historyInfo.dateNowDayActive
            this.dateYesterdayActive = this.historyInfo.dateYesterdayActive
            this.dateNowMonthActive = this.historyInfo.dateNowMonthActive
            this.dateLastMonthActive = this.historyInfo.dateLastMonthActive
            this.ORMTB440CA00 = this.historyInfo.ORMTB440CA00
        },
        // 导出
        // exports() {
        //     // console.log(this.uobj)
        //     let token = sessionStorage.getItem('token')
        //     if (this.uobj.pertb005.pertb005cb00 == 'CUS-2') {
        //         this.customerMo = this.uobj.ormtb410.ORMTB410ID //一级企业id
        //     }
        //     var startTime = this.date[0] //开始时间
        //     var endTime = this.date[1] //结束时间
        //     var ORMTB440CA02 = this.customerMo //二级客户ID
        //     var ORMTB400CA03 = 1002 //一级客户代码
        //     var ORMTB440CA04 = this.enterpriseTwo //二级企业ID
        //     var ORMTB440CA06 = this.materielMo //物料ID
        //     var ORMTB440CF01 = this.SETTB122CA07 //状态
        //     // var ORMTB440CA00 = this.ORMTB440CA00 //订单号
        //     var ORMTB440CA01 = this.carNumber //车牌号
        //     var ORMTB470CA40 = this.ORMTB470CA40 //发单人
        //     var ORMTB410CA04 = this.ORMTB410CA04 //货主
        //     // var ORMTB470CA58 = this.ORMTB470CA58 //运费结算方式
        //     var timeType = this.timeType //
        //     var url =
        //         this.axios.defaults.baseURL +
        //         '/exc/toExcel/ormtb470toExcleSL?startTime=' +
        //         startTime +
        //         '&endTime=' +
        //         endTime +
        //         '&token=' +
        //         token +
        //         '&ORMTB440CA02=' +
        //         ORMTB440CA02 +
        //         '&ORMTB400CA03=' +
        //         ORMTB400CA03 +
        //         '&ORMTB440CA04=' +
        //         ORMTB440CA04 +
        //         '&ORMTB440CA06=' +
        //         ORMTB440CA06 +
        //         '&ORMTB440CF01=' +
        //         ORMTB440CF01 +
        //         // '&ORMTB440CA00=' +
        //         // ORMTB440CA00 +
        //         '&ORMTB440CA01=' +
        //         ORMTB440CA01 +
        //         '&ORMTB470CA40=' +
        //         ORMTB470CA40 +
        //         '&ORMTB410CA04=' +
        //         ORMTB410CA04 +
        //         // '&ORMTB470CA58=' +
        //         // ORMTB470CA58 +
        //         '&timeType=' +
        //         timeType
        //     window.location.href = url

        //     this.loadingBut = true
        //     var timer = null //倒计时
        //     this.confirmTxt = 30 - 1
        //     timer = setInterval(() => {
        //         if (this.confirmTxt === 0) {
        //             this.confirmTxt = ''
        //             this.loadingBut = false
        //             clearInterval(timer)
        //         } else {
        //             this.confirmTxt--
        //         }
        //     }, 1000)
        // },
        topWeightInput() {
            this.detailsList.ORMTB440CE02 = this.detailsList.ORMTB440CE02.replace(
                /[^\d.]/g,
                ''
            ) //清除“数字”和“.”以外的字符
            this.detailsList.ORMTB440CE02 = this.detailsList.ORMTB440CE02.replace(
                /^\./g,
                ''
            ) //验证第一个字符是数字
            this.detailsList.ORMTB440CE02 = this.detailsList.ORMTB440CE02.replace(
                /\.{2,}/g,
                '.'
            ) //只保留第一个. 清除多余的
            this.detailsList.ORMTB440CE02 = this.detailsList.ORMTB440CE02.replace(
                '.',
                '$#$'
            )
                .replace(/\./g, '')
                .replace('$#$', '.')
            this.detailsList.ORMTB440CE02 = this.detailsList.ORMTB440CE02.replace(
                /^(\-)*(\d+)\.(\d\d).*$/,
                '$1$2.$3'
            ) //只能输入两个小数
            if (
                this.detailsList.ORMTB440CE02.indexOf('.') < 0 &&
                this.detailsList.ORMTB440CE02 != ''
            ) {
                //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
                this.detailsList.ORMTB440CE02 = parseFloat(
                    this.detailsList.ORMTB440CE02
                )
            }
            this.$refs.topWeight.value = this.detailsList.ORMTB440CE02
        },
        topWeightChange() {
            var index = String(this.detailsList.ORMTB440CE02).indexOf('.')
            if (index == -1) return
            var numArr = this.detailsList.ORMTB440CE02.split('.')
            if (numArr[1].length == 0) {
                this.$refs.topWeight.value = numArr[0]
                this.detailsList.ORMTB440CE02 = numArr[0]
            } else {
                this.$refs.topWeight.value = numArr[0] + '.' + numArr[1]
                this.detailsList.ORMTB440CE02 = numArr[0] + '.' + numArr[1]
            }
        },
        topMoneyInput() {
            //充值金额实时校验
            this.detailsList.ORMTB440CA21 = this.detailsList.ORMTB440CA21.replace(
                /[^\d.]/g,
                ''
            ) //清除“数字”和“.”以外的字符
            this.detailsList.ORMTB440CA21 = this.detailsList.ORMTB440CA21.replace(
                /^\./g,
                ''
            ) //验证第一个字符是数字
            this.detailsList.ORMTB440CA21 = this.detailsList.ORMTB440CA21.replace(
                /\.{2,}/g,
                '.'
            ) //只保留第一个. 清除多余的
            this.detailsList.ORMTB440CA21 = this.detailsList.ORMTB440CA21.replace(
                '.',
                '$#$'
            )
                .replace(/\./g, '')
                .replace('$#$', '.')
            this.detailsList.ORMTB440CA21 = this.detailsList.ORMTB440CA21.replace(
                /^(\-)*(\d+)\.(\d\d).*$/,
                '$1$2.$3'
            ) //只能输入两个小数
            if (
                this.detailsList.ORMTB440CA21.indexOf('.') < 0 &&
                this.detailsList.ORMTB440CA21 != ''
            ) {
                //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
                this.detailsList.ORMTB440CA21 = parseFloat(
                    this.detailsList.ORMTB440CA21
                )
            }
            this.$refs.topMoney.value = this.detailsList.ORMTB440CA21
        },
        topMoneyChange() {
            //充值金额失去焦点数据处理
            var index = String(this.detailsList.ORMTB440CA21).indexOf('.')
            if (index == -1) return
            var numArr = this.detailsList.ORMTB440CA21.split('.')
            if (numArr[1].length == 0) {
                this.$refs.topMoney.value = numArr[0]
                this.detailsList.ORMTB440CA21 = numArr[0]
            } else {
                this.$refs.topMoney.value = numArr[0] + '.' + numArr[1]
                this.detailsList.ORMTB440CA21 = numArr[0] + '.' + numArr[1]
            }
        },
        returnReceiptserve() {
            let loading = this.$loading({
                lock: true,
                text: '请求中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)',
            })
            var postData = {
                ORMTB440CE07: this.uobj.pertb005.pertb005id, //开始时间
                ORMTB440CE08: this.uobj.pertb005.pertb005ca02,
                ORMTB440CE09: this.detailsList.ORMTB440CE02,
                ORMTB440ID: this.detailsList.ORMTB440ID,
                ORMTB440CA21: this.detailsList.ORMTB440CA21,
            }
            this.tableData = []
            var url = '/orm/ormtb440/ormtb440Confirm'
            this.axios
                .post(url, postData)
                .then(res => {
                    setTimeout(() => {
                        loading.close()
                    }, 400)
                    if (res.data.code == 200) {
                        this.$message({
                            message: '确认回执成功',
                            type: 'success',
                        })
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error',
                        })
                    }
                })
                .catch(() => {
                    loading.close()
                })
        },

        djcancelOrder(row, datadj) {
            console.log(row)
            var url = '/orm/ormtb470/updateStatus'
            this.$prompt('请输入原因', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputPattern: /^.{1,}$/,
                inputErrorMessage: '原因不能为空',
            }).then(({ value }) => {
                var postData = {
                    ORMTB470ID: row.ORMTB470ID,
                    ORMTB470CA62: datadj, //状态
                    ORMTB470CA63: value, //冻结解冻原因
                }
                let loading = this.$loading({
                    lock: true,
                    text: '请求中...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.5)',
                })
                this.axios
                    .post(url, postData)
                    .then(res => {
                        if (res.data.code == 200) {
                            this.pageList()
                            this.$message({
                                type: 'success',
                                message: '成功!',
                            })
                        } else {
                            this.$message({
                                message: res.data.message,
                                type: 'error',
                            })
                        }
                        loading.close()
                    })
                    .catch(() => {
                        loading.close()
                    })
            })
        },

        // 取消订单
        cancelOrder(row) {
            var url = '/orm/ormtb470/updateORMTB470CD00'
            this.$prompt('请输入取消原因', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputPattern: /^.{1,}$/,
                inputErrorMessage: '原因不能为空',
            }).then(({ value }) => {
                var postData = {
                    ORMTB470ID: row.ORMTB470ID,
                    // ORMTB440CF01: -1, //状态
                    ORMTB470CA29: value, //取消原因
                }
                let loading = this.$loading({
                    lock: true,
                    text: '请求中...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.5)',
                })
                this.axios
                    .post(url, postData)
                    .then(res => {
                        if (res.data.code == 200) {
                            this.pageList()
                            this.$message({
                                type: 'success',
                                message: '取消成功!',
                            })
                        } else {
                            this.$message({
                                message: res.data.message,
                                type: 'error',
                            })
                        }
                        loading.close()
                    })
                    .catch(() => {
                        loading.close()
                    })
            })
        },
        materielMoPost() {
            var url = '/set/settb109/selectPageListSL'
            let customerMo = '';
            if (this.uobj.pertb005.pertb005cb00 == 'CUS-2') {
                customerMo = this.uobj.ormtb410.ORMTB410ID
            }
            var List = [
                {
                    SETTB109CA00: '全部',
                    SETTB109ID: '',
                },
            ]
            this.axios.post(url, { ORMTB410ID: customerMo }).then(res => {
                if (res.data.code == 200) {
                    this.materielOptions = [...List, ...res.data.data]
                } else {
                    this.$message({
                        message: res.data.message,
                        type: 'error',
                    })
                }
            })
        },
        // 获取下拉框信息--二级企业
        optionLists() {
            let customerMo = '';
            if (this.uobj.pertb005.pertb005cb00 == 'CUS-2') {
                customerMo = this.uobj.ormtb410.ORMTB410ID
            }
            var List = [
                {
                    SETTB99ID: '',
                    SETTB99CA00: '全部',
                },
            ]
            var url = '/set/settb100/selectSettb99s'
            this.axios
                .post(url, { ORMTB410ID: customerMo })
                .then(res => {
                    if (res.data.code == 200) {
                        var data = res.data.data
                        // 二级企业
                        this.enterpriseTwoOptionList = [...List, ...data]
          this.filteredEnterpriseOptions = this.enterpriseTwoOptionList.slice(0, 100)
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error',
                        })
                    }
                    this.pageList()
                })
                .catch(() => {
                    this.pageList()
                    loading.close()
                })
        },
        optionListsXie() {
            let customerMo = '';
            if (this.uobj.pertb005.pertb005cb00 == 'CUS-2') {
                customerMo = this.uobj.ormtb410.ORMTB410ID
            }
            var List = [
                { 
                    ORMTB470CA33: '全部',
                },
            ]
            var url = '/set/settb100/selectXHDs'
            this.axios
                .post(url, { ORMTB410ID: customerMo })
                .then(res => {
                    if (res.data.code == 200) {
                        var data = res.data.data
                        // 二级企业
                        this.enterpriseList = [...List, ...data];
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error',
                        })
                    }
                    this.pageList()
                })
                .catch(() => {
                    this.pageList()
                    loading.close()
                })
        },
        // 查询
        queryClick() {
            this.startTime = this.date[0]
            this.endTime = this.date[1]
            this.pageList()
        },
        // 列表
        pageList() {
            let place = '';
            if(this.enterpriseTwoXie=='全部'){
                place='';
            }else {
                place = this.enterpriseTwoXie;
            }
            let customerMo = '';
            if (this.uobj.pertb005.pertb005cb00 == 'CUS-2') {
                customerMo = this.uobj.ormtb410.ORMTB410ID
            }
            let loading = this.$loading({
                lock: true,
                text: '请求中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)',
            })
            var postData = {
                startTime: this.startTime, //开始时间
                endTime: this.endTime, //结束时间
                ORMTB410ID: customerMo, //二级客户ID
                // ORMTB470CA58: this.ORMTB470CA58,
                // ORMTB410CA03: ORMTB400CA03, //一级客户代码
                ORMTB470CA33:place,//卸货地
                ORMTB470CA04: this.enterpriseTwo, //二级企业ID
                SETTB109CA00: this.materielMo, //物料ID
                ORMTB470CD00: this.SETTB122CA07, //状态
                // ORMTB470CA00: this.ORMTB440CA00, //订单号
                ORMTB470CA01: this.carNumber, //车牌号
                // ORMTB470CA61: this.lxorde, //离线订单
                // ORMTB470CN00: this.xgorde, //修改流水
                // ORMTB470CA12: this.ORMTB470CA12,
                // ORMTB470CA40: this.ORMTB470CA40,
                // ORMTB410CA04: this.ORMTB410CA04,
                page: this.pageMo,
                limit: this.limitMo,
                // timeType: this.timeType,
                // dcmore: '',
            }
            this.tableData = []
            var url = '/orm/ormtb470/selectPageListSL'
            this.axios
                .post(url, postData)
                .then(res => {
                    setTimeout(() => {
                        loading.close()
                    }, 400)
                    // console.log(res)
                    if (res.data.code == 200) {
                        var data = res.data.data.dataList
                        // console.log(data)
                        this.pagingPageMo = res.data.count
                        for (var i = 0; i < data.length; i++) {
                            var customerName = ''
                            if (data[i]['ORMTB470CD00'] == '-1') {
                                data[i]['ORMTB440CF01text'] = '取消'
                            } else if (data[i]['ORMTB470CD00'] == '0') {
                                data[i]['ORMTB440CF01text'] = '已接单'
                            } else if (data[i]['ORMTB470CD00'] == '1') {
                                data[i]['ORMTB440CF01text'] = '提货中'
                            } else if (data[i]['ORMTB470CD00'] == '2') {
                                data[i]['ORMTB440CF01text'] = '已出厂结算'
                            } else if (data[i]['ORMTB470CD00'] == '3') {
                                data[i]['ORMTB440CF01text'] = '待审核磅单'
                            } else if (data[i]['ORMTB470CD00'] == '4') {
                                data[i]['ORMTB440CF01text'] = '已审核待确认'
                            } else if (data[i]['ORMTB470CD00'] == '5') {
                                data[i]['ORMTB440CF01text'] = '已完成'
                            } else if (data[i]['ORMTB470CD00'] == '-2') {
                                data[i]['ORMTB440CF01text'] = '申请取消'
                            } else if (data[i]['ORMTB470CD00'] == '-3') {
                                data[i]['ORMTB440CF01text'] = '磅单审核已拒绝'
                            }

                            if (data[i]['ORMTB470CD00'] == '-2') {
                                if (data[i]['ORMTB470CD01'] == '0') {
                                    data[i]['auditText'] = '未审核'
                                } else if (data[i]['ORMTB470CD01'] == '1') {
                                    data[i]['auditText'] = '通过'
                                } else if (data[i]['ORMTB470CD01'] == '2') {
                                    data[i]['auditText'] = '拒绝'
                                }
                            }

                            // else if (data[i]['ORMTB440CF01'] == '6') {
                            // 	data[i]['auditText'] = '未审核'
                            // }
                            else {
                                data[i]['auditText'] = '通过'
                                // if (data[i].ORMTB440CH00 == 0) {
                                // 	data[i].isauditOrder = 0
                                // }
                                // if (data[i].ORMTB440CH00 == 1 && data[i].ORMTB440CH01 == 0) {
                                // 	data[i].isauditOrder = 1
                                // }
                                // if (data[i].ORMTB440CH00 == 1 && data[i].ORMTB440CH01 == 1) {
                                // 	data[i].isauditOrder = 0
                                // }
                                // if (data[i]['ORMTB440CH01'] == '0') {
                                // 	data[i]['auditText'] = '未审核'
                                // } else if (data[i]['ORMTB440CH01'] == '1') {
                                // 	data[i]['auditText'] = '通过'
                                // } else if (data[i]['ORMTB440CH01'] == '2') {
                                // 	data[i]['auditText'] = '拒绝'
                                // }
                            }
                        }
                        this.tableData = data
                        // this.jscc = res.data.data.jscc
                        // this.jsje = res.data.data.jsje
                        // this.jszl = res.data.data.jszl
                        // this.jsyf = res.data.data.jsyf

                        // this.pdcc = res.data.data.pdcc
                        // this.pdje = res.data.data.pdje
                        // this.pdzl = res.data.data.pdzl
                        // this.pdyf = res.data.data.pdyf

                        this.wccc = res.data.data.wccc
                        this.wcje = res.data.data.wcje
                        // this.wcyf = res.data.data.wcyf
                        // this.jsyfsjtj = res.data.data.wcjsyf
                        // this.glf = res.data.data.fwf
                        this.wczl = res.data.data.wczl
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error',
                        })
                    }
                })
                .catch(() => {
                    loading.close()
                })
        },
        UploadClick(row) {
            this.ORMTB470CA00 = row.ORMTB470ID
        },
        ewmDetailsClick(row) {
            // console.log(row)
            this.ewmDetilsShow = true
            this.queryermdetile(row)
        },
        inputFileChange(e) {
            let file = e.target.files[0]
            let formData = new FormData()
            formData.append('file', file)
            formData.append('ORMTB470ID', this.ORMTB470CA00)
            let loading = this.$loading({
                lock: true,
                text: '上传中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)',
            })
            var url = '/orm/ormtb470/upload'
            this.axios
                .post(url, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                })
                .then(res => {
                    setTimeout(() => {
                        loading.close()
                    }, 400)
                    if (res.data.code == 200) {
                        this.$message({
                            message: '上传成功',
                            type: 'success',
                        })
                        this.pageList()
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error',
                        })
                    }
                })
                .catch(() => {
                    loading.close()
                })
        },
        inputWeightClick(row) {
            console.log(row)
            //
            this.inputWeightShow = true
            if (row.ORMTB470CA04 == '10000108') {
                this.dcjsiput = false
            } else {
                this.dcjsiput = true
            }

            this.orderId = row.ORMTB470CA04
            this.newOrderId = row.ORMTB470ID
            this.querydetile(row)
            this.getSelectMaterial(row)

            this.fileListccbd = []
        },
        inputWeightClose() {
            this.weightOpt.tare = ''
            // this.weightOpt.gross = ''
            // this.detailsList.ORMTB440CC02 = ''
            // this.detailsList.ORMTB440CC02 = ''
            // this.detailsList.ORMTB470CA21 = ''
            this.weightOpt.jsprice = ''
        },
        // 获取结算金额
        async getSettlementAmount() {
            // console.log(typeof this.weightOpt.tare)
            if (!this.materialValue) return
            if (this.weightOpt.price < 0) return
            if (this.weightOpt.tare === '') return

            var params = {
                ORMTB440CC01: this.materialValue,
                ORMTB440CA02: this.detailsList.ORMTB410CA01,
                ORMTB440CA04: this.detailsList.ORMTB470CA04,
                ORMTB440CC03: this.detailsList.ORMTB470CA20,
                ORMTB440CC04: this.weightOpt.tare,
                ORMTB440CC03: this.weightOpt.price,
            }
            params = qs.stringify(params)

            let loading = this.$loading({
                lock: true,
                text: '请求中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)',
            })
            var url = '/orm/ormtb440/orderCompleteBeforeBack'
            this.axios
                .post(url, params, {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                })
                .then(res => {
                    setTimeout(() => {
                        loading.close()
                    }, 400)
                    if (res.data.code == 200) {
                        this.weightOpt.jsprice = res.data.data
                        // this.pageList()
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error',
                        })
                    }
                })
                .catch(() => {
                    loading.close()
                })
        },
        inputWeightConfirm() {
            var {
                ORMTB470ID, // 派单记录ID - 隐藏

                // ORMTB470CA23, // 结算金额 -可修改
            } = this.detailsList
            var ORMTB470CA18 = this.materialValue // 物料id
            var ORMTB470CA19 = this.materialList.find(
                em => em.value === this.materialValue
            ).lable // 结算物料 -可修改
            var {
                tare, // 结算重量 -不修改
            } = this.weightOpt
            if (!tare) {
                return this.$message({
                    message: '请输入净重',
                    type: 'error',
                })
            }

            if (
                this.detailsList.ORMTB470CA04 == '10000106' ||
                this.detailsList.ORMTB470CA66 == '1'
            ) {
                if (this.ruleForm.csAvatar == '') {
                    return this.$message({
                        message: '请上传出厂磅单',
                        type: 'error',
                    })
                }
            }

            if (this.orderId == '10000106' || this.orderId == '10000155') {
                this.dcmore = this.weightOpt.price
            } else {
                this.dcmore = ''
            }
            // if (!gross) {
            // 	return this.$message({
            // 		message: '请输入皮重',
            // 		type: 'error'
            // 	});
            // }
            var params = {
                ORMTB470ID,
                ORMTB470CA18, // 物料id
                ORMTB470CA19: ORMTB470CA19,
                ORMTB470CA21: tare,
                ORMTB470CA67: this.ruleForm.csAvatar,
				fileId: this.ruleForm.fileId,
                //ORMTB440CC03: this.weightOpt.price,
                ORMTB470CA20: this.dcmore,
            }
            params = qs.stringify(params)

            let loading = this.$loading({
                lock: true,
                text: '请求中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)',
            })
            var url = '/orm/ormtb470/update'
            this.axios
                .post(url, params, {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                })
                .then(res => {
                    setTimeout(() => {
                        loading.close()
                    }, 400)
                    if (res.data.code == 200) {
                        this.tableData = []
                        this.$message({
                            message: '提交成功',
                            type: 'success',
                        })
                        this.inputWeightShow = false
                        this.pageList()
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error',
                        })
                    }
                })
                .catch(() => {
                    loading.close()
                })
        },
        inputWeightFormat(e, type, type2) {
            console.log('type', type, type2)
            let value = e.target.value
            // console.log(value)
            // console.log(type)
            value = value.replace(/[^\d.]/g, '') //清除“数字”和“.”以外的字符
            value = value.replace(/^\./g, '') //验证第一个字符是数字
            value = value.replace(/\.{2,}/g, '.') //只保留第一个. 清除多余的
            value = value
                .replace('.', '$#$')
                .replace(/\./g, '')
                .replace('$#$', '.')
            value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3') //只能输入两个小数
            this.weightOpt.tare = value
            if (value.indexOf('.') < 0 && value != '') {
                //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
                value = parseFloat(value)
            }
            this.weightOpt[type] = value

            if (type2 == 'hx') {
                this.getFree() //获取结算运费
            }
        },
        inputWeightFormat1(e, type, type2) {
            let value = e.target.value
            // console.log(value)
            // console.log(type)
            value = value.replace(/[^\d.]/g, '') //清除“数字”和“.”以外的字符
            value = value.replace(/^\./g, '') //验证第一个字符是数字
            value = value.replace(/\.{2,}/g, '.') //只保留第一个. 清除多余的
            value = value
                .replace('.', '$#$')
                .replace(/\./g, '')
                .replace('$#$', '.')
            value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3') //只能输入两个小数
            if (value.indexOf('.') < 0 && value != '') {
                //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
                value = parseFloat(value)
            }

            this.$set(this.weightOpt, 'price', value)

            if (type2 == 'hx') {
                this.getFree() //获取结算运费
            }
        },
        inputWeightTotalFormat(e) {
            let value = e.target.value
            value = value.replace(/[^\d.]/g, '') //清除“数字”和“.”以外的字符
            value = value.replace(/^\./g, '') //验证第一个字符是数字
            value = value.replace(/\.{2,}/g, '.') //只保留第一个. 清除多余的
            value = value
                .replace('.', '$#$')
                .replace(/\./g, '')
                .replace('$#$', '.')
            value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3') //只能输入两个小数
            if (value.indexOf('.') < 0 && value != '') {
                //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
                value = parseFloat(value)
            }
            this.weightOpt.jsprice = value
        },
        // 详情
        DetailsClick(row) {
            // console.log(row)
            this.oerderDetilsShow = true
            this.querydetile(row)
        },
        orderAudit(row) {
            this.orderAuditShow = true
            this.examineObj = row
            this.querydetile(row)
        },
        orderAudit1(row, type) {
            this.orderAuditShow1 = true
            this.examineObj = row
            this.querydetile(row, type)
        },
        orderAudit2(row) {
            this.orderAuditShow2 = true
            this.examineObj = row
            console.log(this.examineObj)
            this.querydetile(row)
        },
        isorderAudit(row) {
            this.isorderAuditShow = true
            this.querydetile(row)
        },
        returnReceipt(row) {
            this.returnReceiptShow = true
            this.querydetile(row)
        },
        examineOrder() {
            let loading = this.$loading({
                lock: true,
                text: '请求中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)',
            })
            var postData = {
                ORMTB470ID: this.examineObj.ORMTB470ID,
                ORMTB470CA48: this.detailsList.ORMTB470CA48,
            }
            this.tableData = []
            var url = '/orm/ormtb470/examine'
            this.axios
                .post(url, postData)
                .then(res => {
                    setTimeout(() => {
                        loading.close()
                    }, 400)
                    if (res.data.code == 200) {
                        this.$message({
                            message: '审核成功',
                            type: 'success',
                        })
                        this.orderAuditShow = false
                        this.pageList()
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error',
                        })
                    }
                })
                .catch(() => {
                    loading.close()
                })
        },

        examineWriteOffOrder() {
            //核销磅单
            let loading = this.$loading({
                lock: true,
                text: '请求中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)',
            })
            var postData = {
                ORMTB470ID: this.examineObj.ORMTB470ID,
                ORMTB470CC05: this.detailsList.ORMTB470CC05,
                ORMTB470CA14: this.detailsList.ORMTB470CA14,
                ORMTB470CA33: this.detailsList.ORMTB470CA33,
                ORMTB470CA72: this.detailsList.ORMTB470CA72,
            }
            this.tableData = []
            var url = '/orm/ormtb470/complete'
            this.axios
                .post(url, postData)
                .then(res => {
                    setTimeout(() => {
                        loading.close()
                    }, 400)
                    if (res.data.code == 200) {
                        this.$message({
                            message: '成功',
                            type: 'success',
                        })
                        this.orderAuditShow1 = false
                        this.pageList()
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error',
                        })
                    }
                })
                .catch(() => {
                    loading.close()
                })
        },

        examinebdOffOrder() {
            //上传磅单

            // console.log(this.detailsList.ph)
            if (this.detailsList.ph == '' || this.detailsList.ph == undefined) {
                this.$message({
                    message: '请输入票号',
                    type: 'error',
                })
                return
            }
            if (this.detailsList.ORMTB470CC05 == '') {
                this.$message({
                    message: '请输入卸货重量',
                    type: 'error',
                })
                return
            }

            // this.formData.fileList.push({
            // 	url: this.dialogImageUrl

            // });

            // this.formData.fileList.push(this.dialogImageUrl)
            // console.log(this.formData.fileList)
            // console.log(this.dialogImageUrl)

            if (this.formData.fileList.length <= 0) {
                this.$message({
                    message: '请上传磅单',
                    type: 'error',
                })
                return
            }
            // if (this.dialogImageUrl=='') {
            // 	this.$message({
            // 		message: '请上传磅单',
            // 		type: 'error'
            // 	});
            // 	return
            // }

            let loading = this.$loading({
                lock: true,
                text: '请求中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)',
            })
            var postData = {
                ORMTB470ID: this.examineObj.ORMTB470ID,
                ORMTB470CA35: this.formData.fileList[0].url,
				fileId:this.formData.fileId,
                ORMTB470CA48: this.detailsList.ph,
                ORMTB470CC05: this.detailsList.ORMTB470CC05,
            }
            var url = '/orm/ormtb470/confirm'
            this.axios
                .post(url, postData)
                .then(res => {
                    setTimeout(() => {
                        loading.close()
                    }, 400)
                    if (res.data.code == 200) {
                        this.$message({
                            message: '成功',
                            type: 'success',
                        })
                        this.orderAuditShow2 = false
                        this.pageList()
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error',
                        })
                    }
                })
                .catch(() => {
                    loading.close()
                })
        },

        queryermdetile(row) {
            var postData = {
                ORMTB470ID: row.ORMTB470ID, //流水id
            }
            this.detailsList = ''
            var url = '/orm/ormtb470/getErwei'
            this.axios.post(url, postData).then(res => {
                if (res.data.code == 200) {
                    console.log(res)
                    this.ewmdetailsList = res.data.data
                    this.ewmdetailsList.ORMTB440CA22Img =
                        'data:image/png;base64,' + res.data.data.ORMTB470CA30
                } else {
                    this.$message({
                        message: res.data.message,
                        type: 'error',
                    })
                }
            })
        },
        updateOrder() {
            var url = '/orm/ormtb470/updateORMTB470CA44'
            this.$prompt('请输入原因', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputPattern: /^.{1,}$/,
                inputErrorMessage: '原因不能为空',
            }).then(({ value }) => {
                var postData = {
                    ORMTB470CA44: value,
                    ORMTB470ID: this.examineObj.ORMTB470ID,
                }
                let loading = this.$loading({
                    lock: true,
                    text: '请求中...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.5)',
                })
                this.tableData = []
                this.axios
                    .post(url, postData)
                    .then(res => {
                        setTimeout(() => {
                            loading.close()
                        }, 400)
                        if (res.data.code == 200) {
                            this.$message({
                                message: '审核成功',
                                type: 'success',
                            })
                            this.orderAuditShow = false
                            this.pageList()
                        } else {
                            this.$message({
                                message: res.data.message,
                                type: 'error',
                            })
                        }
                    })
                    .catch(() => {
                        loading.close()
                    })
            })
        },

        orderAuditServe(type) {
            let loading = this.$loading({
                lock: true,
                text: '请求中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)',
            })
            var postData = {
                ORMTB440CG00: type,
                ORMTB440CG02: this.uobj.pertb005.pertb005ca02,
                ORMTB440ID: this.detailsList.ORMTB440ID,
                ORMTB440CA02: this.detailsList.ORMTB440CA02,
                ORMTB440CA11: this.detailsList.ORMTB440CA11,
                ORMTB440CA12: this.detailsList.ORMTB440CA12,
            }
            this.tableData = []
            var url = '/orm/ormtb440/updateORMTB440CG00'
            this.axios
                .post(url, postData)
                .then(res => {
                    setTimeout(() => {
                        loading.close()
                    }, 400)
                    if (res.data.code == 200) {
                        this.$message({
                            message: '审核成功',
                            type: 'success',
                        })
                        this.orderAuditShow = false
                        this.pageList()
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error',
                        })
                    }
                })
                .catch(() => {
                    loading.close()
                })
        },
        isorderAuditServe(type) {
            // console.log(type)
            let loading = this.$loading({
                lock: true,
                text: '请求中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)',
            })
            var postData = {
                ORMTB470CD01: type,
                ORMTB470ID: this.detailsList.ORMTB470ID,
                ORMTB470CA44: this.isorderAuditText,
            }
            this.tableData = []
            var url = '/orm/ormtb470/updateORMTB470CD01NEW'
            this.axios
                .post(url, postData)
                .then(res => {
                    setTimeout(() => {
                        loading.close()
                    }, 400)
                    if (res.data.code == 200) {
                        this.$message({
                            message: '审核成功',
                            type: 'success',
                        })
                        this.isorderAuditShow = false
                        this.pageList()
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error',
                        })
                    }
                })
                .catch(() => {
                    loading.close()
                })
        },
        querydetile(row, type) {
            var postData = {
                ORMTB470ID: row.ORMTB470ID, //流水id
            }
            this.detailsList = ''
            var url = '/orm/ormtb470/selectDetails'
            this.axios.post(url, postData).then(res => {
                if (res.data.code == 200) {
                    // console.log(res)
                    this.detailsList = res.data.data

                    this.weightOpt.price = this.detailsList.ORMTB470CA08
                    console.log(this.detailsList)

                    this.dialogVisible = true
                    this.dialogImageUrl = this.detailsList.ORMTB470CA35
                    this.bdurlList.push(this.detailsList.ORMTB470CA35)

                    // console.log(this.detailsList)
                    // this.DetailsWatersrcList = [this.detailsList.ORMTB440CE01]
                    if (this.detailsList.ORMTB470CA35)
                        this.DetailsWeightrcList = [this.detailsList.ORMTB470CA35]
                    // this.weightOpt.price = this.detailsList.ORMTB470CA08
                    // console.log(row.ORMTB470CD00)
                    if (row.ORMTB470CD00 == 0 && row.ORMTB470CA30) {
                        this.weightOpt.tare = 0
                        // this.weightOpt.jsprice = ''
                        this.getSelectMaterial(row)
                    }
                    if (type == 'hx') {
                        this.getFree() //获取结算运费
                    }
                } else {
                    this.$message({
                        message: res.data.message,
                        type: 'error',
                    })
                }
            })
        },
        handleCheckAllChange(val) {
            this.checkedCities = val ? this.cities : []
            this.isIndeterminate = false
            this.tableHeadList = val ? this.tableHeadListInit : []
        },
        handleCheckedCitiesChange(value) {
            let checkedCount = value.length
            this.checkAll = checkedCount === this.cities.length
            this.isIndeterminate =
                checkedCount > 0 && checkedCount < this.cities.length
            var changearr = this.checkedCities
            var initarr = this.tableHeadListInit
            this.tableHeadList = this.$baseAPI.columnSetup(changearr, initarr)
        },

        dateFtt(fmt, date) {
            //author: meizz
            var o = {
                'M+': date.getMonth() + 1, //月份
                'd+': date.getDate(), //日
                'h+': date.getHours(), //小时
                'm+': date.getMinutes(), //分
                's+': date.getSeconds(), //秒
                'q+': Math.floor((date.getMonth() + 3) / 3), //季度
                S: date.getMilliseconds(), //毫秒
            }
            if (/(y+)/.test(fmt))
                fmt = fmt.replace(
                    RegExp.$1,
                    (date.getFullYear() + '').substr(4 - RegExp.$1.length)
                )
            for (var k in o)
                if (new RegExp('(' + k + ')').test(fmt))
                    fmt = fmt.replace(
                        RegExp.$1,
                        RegExp.$1.length == 1
                            ? o[k]
                            : ('00' + o[k]).substr(('' + o[k]).length)
                    )
            return fmt
        },

        //获取当前时间
        getNowDay() {
            var date = new Date().getTime()
            var Ming = new Date().getTime() + 24 * 60 * 60 * 1000
            var data = this.dateFtt('yyyy-MM-dd', new Date(Ming))
            var enddata = this.dateFtt('yyyy-MM-dd', new Date(date))
            data = `${data} ${this.exchangeTiem || '00:00:00'}`
            enddata = `${enddata} ${this.exchangeTiem || '00:00:00'}`
            this.date = [enddata, data]
            this.dateNowDayActive = true
            this.dateYesterdayActive = false
            this.dateNowMonthActive = false
            this.dateLastMonthActive = false
        },
        datePickerChange(e) {
            this.dateNowDayActive = false
            this.dateYesterdayActive = false
            this.dateNowMonthActive = false
            this.dateLastMonthActive = false
        },
        //获取昨天时间
        getYesterday() {
            var hms = new Date().getTime() - 24 * 60 * 60 * 1000
            var Ming = new Date().getTime()
            var nowDay = this.dateFtt('yyyy-MM-dd', new Date(hms))
            var enddata = this.dateFtt('yyyy-MM-dd', new Date(Ming))
            nowDay = `${nowDay} ${this.exchangeTiem || '00:00:00'}`
            enddata = `${enddata} ${this.exchangeTiem || '00:00:00'}`
            this.date = [nowDay, enddata]
            this.dateNowDayActive = false
            this.dateYesterdayActive = true
            this.dateNowMonthActive = false
            this.dateLastMonthActive = false
        },
        //获取当月时间
        sameMonth() {
            var date = new Date()
            var hms = date.setDate(1)
            var firstDay = this.dateFtt('yyyy-MM-dd', new Date(hms))
            firstDay = `${firstDay} ${this.exchangeTiem || '00:00:00'}`
            var nextdate = new Date().getTime() + 24 * 60 * 60 * 1000
            var nextDay = this.dateFtt('yyyy-MM-dd', new Date(nextdate))
            nextDay = `${nextDay} ${this.exchangeTiem || '00:00:00'}`
            this.date = [firstDay, nextDay]
            this.startTime = this.date[0]
            this.endTime = this.date[1]
            this.dateNowDayActive = false
            this.dateYesterdayActive = false
            this.dateNowMonthActive = true
            this.dateLastMonthActive = false
        },
        //获取上月时间
        lastMonth() {
            var nowdays = new Date()
            var year = nowdays.getFullYear()
            var month = nowdays.getMonth()
            var lastyear = year
            var lastmonth = month
            if (month == 0) {
                month = 12
                year = year - 1
            }
            if (month == 12) {
                lastmonth = 1
            } else {
                lastmonth = lastmonth + 1 * 1
            }
            if (month < 10) {
                month = '0' + month
            }
            if (lastmonth < 10) {
                lastmonth = '0' + lastmonth
            }
            var firstDayOfPreMonth = year + '-' + month + '-' + '01'
            var firstDayOfPreMonth = `${year}-${month}-01 ${this.exchangeTiem ||
                '00:00:00'}`
            // var lastDay = new Date(lastyear, lastmonth, 0);
            let lastDayOfPreMonth = `${lastyear}-${lastmonth}-01 ${this
                .exchangeTiem || '00:00:00'}`
            this.date = [firstDayOfPreMonth, lastDayOfPreMonth]
            this.dateNowDayActive = false
            this.dateYesterdayActive = false
            this.dateNowMonthActive = false
            this.dateLastMonthActive = true
        },
        handleSizeChange(val) {
            this.pageMo = 1
            this.limitMo = val
            this.pageList()
        },
        // 点击页码
        handleCurrentChange(val) {
            this.pageMo = val
            this.pageList()
        },
    },
}
</script>

<style scoped>
.receipt-shipping-page {
    min-height: 100%;
    padding: 12px;
    box-sizing: border-box;
    background:
        radial-gradient(circle at 12% 4%, rgba(36, 167, 255, 0.14), transparent 28%),
        linear-gradient(180deg, #eef7ff 0%, #f5f7fb 42%, #f3f6fa 100%);
    color: #263238;
}

.receipt-hero-card,
.receipt-filter-card,
.receipt-stat-card,
.receipt-table-card {
    border: 1px solid rgba(190, 218, 238, 0.72);
    border-radius: 18px;
    box-shadow: 0 14px 36px rgba(30, 86, 130, 0.08);
}

.receipt-hero-card {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-height: 112px;
    margin-bottom: 10px;
    padding: 24px 28px;
    overflow: hidden;
    box-sizing: border-box;
    background: linear-gradient(135deg, #0f7fc5 0%, #20a6d9 52%, #55c7b4 100%);
    color: #fff;
}

.receipt-hero-card::after {
    content: '';
    position: absolute;
    right: -48px;
    top: -68px;
    width: 230px;
    height: 230px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.18);
}

.receipt-hero-eyebrow {
    position: relative;
    z-index: 1;
    margin-bottom: 8px;
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 4px;
    opacity: 0.86;
}

.receipt-hero-title {
    position: relative;
    z-index: 1;
    font-size: 30px;
    line-height: 38px;
    font-weight: 700;
    letter-spacing: 1px;
}

.receipt-hero-subtitle {
    position: relative;
    z-index: 1;
    margin-top: 8px;
    font-size: 14px;
    color: rgba(255, 255, 255, 0.82);
}

.receipt-hero-refresh {
    position: relative;
    z-index: 1;
    min-width: 130px;
    padding: 12px 18px;
    border: 1px solid rgba(255, 255, 255, 0.36);
    border-radius: 16px;
    background: rgba(255, 255, 255, 0.16);
    text-align: right;
    backdrop-filter: blur(8px);
}

.receipt-hero-refresh span,
.receipt-hero-refresh strong {
    display: block;
}

.receipt-hero-refresh span {
    margin-bottom: 5px;
    font-size: 12px;
    color: rgba(255, 255, 255, 0.78);
}

.receipt-hero-refresh strong {
    font-size: 18px;
    font-weight: 700;
}

.receipt-filter-card {
    margin-bottom: 8px;
    padding: 12px 16px;
    background: rgba(255, 255, 255, 0.95);
}

.receipt-card-title,
.receipt-table-toolbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
}

.receipt-section-title {
    position: relative;
    padding-left: 12px;
    font-size: 18px;
    line-height: 24px;
    font-weight: 700;
    color: #1f3a4a;
}

.receipt-section-title::before {
    content: '';
    position: absolute;
    left: 0;
    top: 5px;
    width: 4px;
    height: 14px;
    border-radius: 4px;
    background: linear-gradient(180deg, #199fff, #20da9c);
}

.receipt-section-subtitle {
    margin-top: 4px;
    padding-left: 12px;
    font-size: 12px;
    color: #7b8c98;
}

.receipt-filter-fields {
    display: grid;
    grid-template-columns: repeat(5, minmax(170px, 1fr));
    gap: 14px 16px;
    width: 100%;
}

.billOperationRecord .receipt-filter-item {
    display: block;
    height: auto;
    margin: 0;
}

.receipt-filter-item .public_lbSty {
    display: block;
    margin-bottom: 8px;
    color: #516674;
    font-size: 13px;
    line-height: 18px;
    font-weight: 700;
}

.receipt-filter-item .public_optionSty,
.receipt-filter-item .el-select,
.receipt-filter-item .el-input,
.receipt-filter-item .dropDown_Define {
    width: 100% !important;
}

.receipt-filter-item .pulic_carNumber {
    width: 100%;
    margin-top: 0;
    border-color: #d9e7f0;
    border-radius: 10px;
    color: #263238;
    background: #fbfdff;
}

.receipt-toolbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 14px;
    margin-top: 10px;
    padding-top: 10px;
    border-top: 1px solid #edf3f7;
}

.receipt-date-shortcuts {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
}

.receipt-date-pill {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 58px;
    height: 32px;
    padding: 0 14px;
    border: 1px solid #d6e7f2;
    border-radius: 18px;
    box-sizing: border-box;
    background: #f7fbfe;
    color: #49606e;
    font-size: 13px;
    transition: all 0.18s ease;
}

.receipt-date-pill:hover {
    border-color: #199fff;
    background: #ecf8ff;
    color: #0f7fc5;
}

.receipt-shipping-page .public_dateActive {
    border-color: #199fff !important;
    background: linear-gradient(135deg, #199fff, #20b8d8) !important;
    color: #fff !important;
    box-shadow: 0 8px 18px rgba(25, 159, 255, 0.22);
}

.receipt-date-picker-wrap {
    overflow: hidden;
    border-radius: 10px !important;
}

.receipt-actions {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-left: auto;
}

.receipt-query-btn,
.receipt-reset-btn {
    min-width: 82px;
    height: 34px;
    padding: 0 18px;
    border-radius: 10px;
    font-weight: 700;
}

.receipt-query-btn {
    border-color: #199fff;
    background: linear-gradient(135deg, #199fff, #12aee5);
    box-shadow: 0 8px 18px rgba(25, 159, 255, 0.22);
}

.receipt-reset-btn {
    border-color: #cde6dc;
    color: #159b75;
    background: #ecfbf6;
}

.receipt-stat-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 14px;
    height: auto !important;
    margin: 0 0 14px;
    padding: 0;
    border: 0;
    background: transparent;
    box-shadow: none;
}

.receipt-stat-card {
    position: relative;
    min-height: 128px;
    padding: 22px 24px;
    overflow: hidden;
    box-sizing: border-box;
    background: #fff;
}

.receipt-stat-card::after {
    content: '';
    position: absolute;
    right: -28px;
    bottom: -42px;
    width: 118px;
    height: 118px;
    border-radius: 50%;
    opacity: 0.16;
}

.receipt-stat-card-trips::after {
    background: #199fff;
}

.receipt-stat-card-weight::after {
    background: #20da9c;
}

.receipt-stat-card-amount::after {
    background: #ffb347;
}

.receipt-stat-content {
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    gap: 18px;
}

.receipt-stat-icon {
    flex: 0 0 auto;
    width: 54px;
    height: 54px;
    padding: 10px;
    border-radius: 16px;
    background: #f0f8ff;
    box-sizing: border-box;
}

.receipt-stat-label {
    margin: 0 0 8px;
    color: #71818d;
    font-size: 14px;
    line-height: 20px;
    font-weight: 700;
}

.receipt-stat-value {
    max-width: 100%;
    color: #1f3a4a;
    font-size: 34px;
    line-height: 40px;
    font-weight: 800;
    word-break: break-all;
}

.receipt-table-card {
    padding: 20px 20px 0;
    background: #fff;
}

.receipt-table-total {
    min-width: 92px;
    padding: 7px 14px;
    border-radius: 15px;
    background: #eef8ff;
    color: #0f7fc5;
    text-align: center;
    font-size: 13px;
    font-weight: 700;
}

.receipt-status-tag {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 72px;
    height: 26px;
    padding: 0 10px;
    border-radius: 13px;
    box-sizing: border-box;
    font-size: 12px;
    font-weight: 700;
}

.receipt-status-done {
    background: #e9faf4;
    color: #10a777;
}

.receipt-status-wait {
    background: #fff6e8;
    color: #d8840d;
}

.receipt-empty {
    padding: 44px 0;
    text-align: center;
}

.receipt-empty-title {
    color: #334955;
    font-size: 16px;
    font-weight: 700;
}

.receipt-empty-desc {
    margin-top: 8px;
    color: #8fa1ad;
    font-size: 13px;
}

.receipt-pagination {
    display: flex;
    justify-content: flex-end;
    padding: 18px 0 20px;
}

.DetailsWater-Dialog {
    max-height: 68vh;
    overflow-y: auto;
    padding-right: 6px;
}

.DWD-li {
    display: flex;
    align-items: center;
    min-height: 38px;
    margin-bottom: 14px;
    border: none !important;
    box-sizing: border-box;
    color: #333;
    font-size: 16px;
}

.DWD-li>div {
    padding: 0 5px;
    min-height: 34px;
    overflow: hidden;
    box-sizing: border-box;
}

.DWD-li-title {
    width: 150px;
    flex: 0 0 150px;
    border-right: none !important;
    background-color: transparent !important;
    color: #425766;
    text-align: left;
    font-size: 14px;
    font-weight: 700;
}

.DWD-li-text {
    flex: 1;
    width: 100%;
    min-height: 34px;
    line-height: 32px;
    padding: 0 12px !important;
    border: 1px solid #dbe7ef;
    border-radius: 8px;
    background: #fbfdff;
    color: #667985;
    font-size: 13px;
}

.DWD-li+.DWD-li {
    border-top: none;
}

.DWD-table {
    display: flex;
    overflow: hidden;
    border-top: 1px solid #d8e6ef;
    border-left: 1px solid #d8e6ef;
    border-radius: 10px;
}

.DWD-table-left-flex {
    flex: 1;
}

.DWD-table>div>div {
    height: 38px;
    padding: 0 8px;
    overflow: hidden;
    border-right: 1px solid #d8e6ef;
    border-bottom: 1px solid #d8e6ef;
    box-sizing: border-box;
    text-align: center;
    line-height: 38px;
}

.DWD-table>div>div:first-child,
.DWD-table-left-title>div {
    background: linear-gradient(135deg, #199fff, #20b8d8);
    color: #fff;
    font-weight: 700;
}

.DWD-table-left-title>div {
    width: 101px;
    text-align: center;
}

.DWD-table .DWD-table-left-title>div {
    height: 38px;
    padding: 0 8px;
    overflow: hidden;
    border-bottom: 1px solid #d8e6ef;
    box-sizing: border-box;
    line-height: 38px;
}

.DetailsWater-img {
    margin-top: 24px;
}

.DetailsWater-img-text {
    display: inline-block;
    width: 101px;
    color: #425766;
    text-align: center;
    vertical-align: top;
    font-weight: 700;
}

.billOperationRecord .systemCodePC-add-code-table-li-ipt {
    flex: 1.5;
}

.fontBlue {
    color: rgba(25, 159, 255, 1) !important;
}

.billOperationRecord th,
.billOperationRecord td {
    text-align: center !important;
}

.input_ {
    display: flex;
    height: 2.34vw;
    line-height: 2vw;
}

.pulic_cursor_round {
    border-radius: 4px !important;
}

::v-deep .receipt-filter-card .el-input__inner,
::v-deep .receipt-date-picker .el-input__inner {
    height: 36px;
    border-color: #d9e7f0;
    border-radius: 10px;
    background: #fbfdff;
    color: #263238;
    line-height: 36px;
}

::v-deep .receipt-filter-card .el-input__inner:focus,
::v-deep .receipt-date-picker .el-input__inner:focus {
    border-color: #199fff;
    box-shadow: 0 0 0 3px rgba(25, 159, 255, 0.12);
}

::v-deep .receipt-date-picker.el-date-editor--datetimerange.el-input__inner {
    width: 380px;
}

::v-deep .receipt-main-table {
    border-radius: 12px;
    overflow: hidden;
}

::v-deep .receipt-main-table .el-table__header th {
    height: 46px;
}

::v-deep .receipt-main-table .el-table__row td {
    height: 48px;
    color: #455a64;
}

::v-deep .receipt-main-table .el-table__row:hover > td {
    background-color: #f0f9ff !important;
}

::v-deep .receipt-pagination .el-pagination__total,
::v-deep .receipt-pagination .el-pagination__jump {
    color: #647783;
}

::v-deep .receipt-pagination .el-pager li.active {
    background: #199fff;
    color: #fff;
    border-radius: 6px;
}

::v-deep .receipt-detail-dialog {
    border-radius: 16px;
    overflow: hidden;
}

::v-deep .receipt-detail-dialog .el-dialog__header {
    margin: 0 24px;
    padding: 20px 0 16px !important;
    border-bottom: 1px solid #e5edf3;
    font-size: 20px;
    font-weight: 700;
}

::v-deep .receipt-detail-dialog .el-dialog__body {
    padding: 22px 24px 26px;
}

@media (max-width: 1400px) {
    .receipt-filter-fields {
        grid-template-columns: repeat(3, minmax(180px, 1fr));
    }
}

@media (max-width: 960px) {
    .receipt-shipping-page {
        padding: 12px;
    }

    .receipt-hero-card,
    .receipt-toolbar,
    .receipt-table-toolbar {
        align-items: flex-start;
        flex-direction: column;
    }

    .receipt-filter-fields,
    .receipt-stat-grid {
        grid-template-columns: 1fr;
    }

    .receipt-actions,
    .receipt-query-btn,
    .receipt-reset-btn {
        width: 100%;
    }

    ::v-deep .receipt-date-picker.el-date-editor--datetimerange.el-input__inner {
        width: 100%;
    }
}
</style>
